import React, { useRef, useEffect, useState } from 'react';
import opentype from 'opentype.js';
// import MSDF from './components/msdf.js';
// import WebGLFont from './components/WebGLFont';
import WebGLFontComponent from './components/WebGLFontComponent';
import WebGLFont from './components/WebGLFont'; // Adjust the path as necessary
import WebGLFontTest from './components/WebGLFontTest'
import { InlineMath, BlockMath } from 'react-katex';
import 'katex/dist/katex.min.css';

const App = () => {
  const canvasRef = useRef(null);
  const canvasCPURef = useRef(null);
  const webGLRef = useRef(null);
  // const text = "Hello, World!";
  const [text, setText] = useState("Hello, World!")

  const [loaded, setLoaded] = useState(false);

  const [openTypeRenderTime, setOpenTypeRenderTime] = useState(0)
  const [cpuRenderTime, setCpuRenderTime] = useState(0);
  const [gpuPerformanceTime, setGpuPerformanceTime] = useState(0)
  const [gpuRenderTime, setGpuRenderTime] = useState(0);

  const [inputValue, setInputValue] = useState(""); // New state to hold the value of the input field

  const handleInputChange = (event) => {
    setInputValue(event.target.value); // Update the inputValue state whenever the input changes
  };

  const handleRenderText = () => {
    setText(inputValue); // Set the text to the current value of the input field when the button is clicked
  };
  

  function enableHighDPICanvas(canvas) {
    if (!canvas) return;
    const pixelRatio = window.devicePixelRatio || 1;
    // Adjust the drawing buffer based on the pixel ratio
    canvas.width = canvas.offsetWidth * pixelRatio;
    canvas.height = canvas.offsetHeight * pixelRatio;
    // Ensure the canvas does not appear larger on the page
    canvas.style.width = canvas.offsetWidth + 'px';
    canvas.style.height = canvas.offsetHeight + 'px';
    // Scale the context to counteract the increased size of the drawing buffer
    canvas.getContext('2d').scale(pixelRatio, pixelRatio);
  }

  function getDrawOptions(font) {
    const options = {
        kerning: true,
        hinting: true,
        features: {
            liga: true,
            rlig: true
        }
    };
    return Object.assign({}, font.defaultRenderOptions, options);
  }

  useEffect(() => { // Doing the font rendering using the OpenType library
    // Load a font (ensure the path to the font is correct)
    const start = performance.now();
    opentype.load('arial.ttf', function(err, font) {
      if (err) {
        console.error('Font could not be loaded:', err);
      } else {
        const canvas = canvasRef.current;
        // enableHighDPICanvas(canvas); // Enable high DPI adjustments
        const ctx = canvas.getContext('2d');
        const fontSize = 124;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        font.draw(ctx, text, 75, 200, fontSize, options);
        var options = getDrawOptions(font);
        // font.drawPoints(ctx, text, 10, 200, fontSize, options);
        const end = performance.now();
        setOpenTypeRenderTime(end - start);
        console.log(`Font drawing with OpenType took ${end - start} milliseconds.`);
      }
    });
  }, [text]);
  
  useEffect(() => { // Doing the font rendering using the canvas API
    // Load the font
    const start = performance.now();
    opentype.load('arial.ttf', function(err, font) {
      if (err) {
        console.error('Font could not be loaded:', err);
      } else {
        const canvas = canvasCPURef.current;
        // enableHighDPICanvas(canvas);
        const ctx = canvas.getContext('2d');
        const fontSize = 124;
        const y = 200; // Y offset on the canvas (baseline)
        
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        let x = 75; // X offset on the canvas, start at 10

        // Draw each character
        text.split('').forEach(char => {
          const glyph = font.charToGlyph(char);
          const scale = fontSize / font.unitsPerEm; // Scale the glyph to the desired font size
          const path = glyph.getPath(x, y, fontSize); // Pass x dynamically

          ctx.beginPath(); // Begin a new path for each glyph

          // Draw the glyph path
          path.commands.forEach(cmd => {
            switch(cmd.type) {
              case 'M':
                ctx.moveTo(cmd.x, cmd.y);
                break;
              case 'L':
                ctx.lineTo(cmd.x, cmd.y);
                break;
              case 'C':
                ctx.bezierCurveTo(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
                break;
              case 'Q':
                ctx.quadraticCurveTo(cmd.x1, cmd.y1, cmd.x, cmd.y);
                break;
              case 'Z':
                ctx.closePath();
                break;
            }
          });

          ctx.stroke(); // Stroke the path
          ctx.fill();

          // Optionally draw control points
          // path.commands.forEach(cmd => {
          //   if (cmd.type === 'C' || cmd.type === 'Q') {
          //     ctx.fillRect(cmd.x1 - 2, cmd.y1 - 2, 4, 4); // Draw control point
          //     if (cmd.type === 'C') {
          //       ctx.fillRect(cmd.x2 - 2, cmd.y2 - 2, 4, 4); // Second control point for cubic
          //     }
          //   }
          // });

          // Increment x position by the glyph's advance width scaled to the font size
          x += glyph.advanceWidth * scale;
        });
        const end = performance.now();
        setCpuRenderTime(end - start)
        console.log(`Font drawing with CPU took ${end - start} milliseconds.`);
      }
    });

  }, [text]);

  useEffect(() => {
      const word = "Congratulations, Class of 2024!";
      const position = [-150, -40, 0];
      const rotation = [Math.PI, 0, 0];
      const zoom = 100;
      const start = performance.now();
      const webGLFont = new WebGLFont({
        word, position, rotation, zoom
      })
      const end = performance.now();
      setGpuRenderTime(end - start)

  }, [])

  useEffect(() => {
    const position = [-130, -10, 0];
    const rotation = [Math.PI, 0, 0];
    const zoom = 70;
    const start = performance.now();
    const webGLFont = new WebGLFontTest({
      word: text, position, rotation, zoom
    })
    const end = performance.now();
    setGpuPerformanceTime(end - start)
    

}, [text])

  return (
    <div className="flex flex-col items-center min-h-screen px-10 py-20 gap-6 max-w-5xl mx-auto">
      <div>
        <h1 class="text-4xl font-bold underline decoration-sky-500 text-center">GPU-Accelerated Font Rendering</h1>
        <p class="text-center">Razvan Cristian Turcu, Ziyan Yu, Angel Rodriguez, Luis Navarrete</p>
      <h2 class="text-center font-bold">CS184: Computer Graphics</h2>
      </div>
      <div class="flex flex-col gap-2">
        <h2 class="text-2xl text-center font-bold underline decoration-sky-500">Abstract</h2>
        <p>
          For our final project in the CS184: Computer Graphics course, we developed a GPU-Accelerated Font Rasterizer optimized for web applications. Our project leverages ThreeJS [3], a powerful 3D rendering library, to display text. In contrast to the typical use of Signed-Distance Fields (SDF), our technique employs Multi-Channel Distance Fields (MSDF), which allow for the rendering of fonts with sharp corners—something not possible with SDFs. 
        </p>
        <p>
        The core of our project involved creating a ThreeJS material through texture mapping MSDF texture maps onto them. This required the development of custom WebGL shaders to accurately interpret these textures and render them onto the canvas. Our approach highlights the speed efficiency of GPU rendering and its ability to maintain high-quality text display at various sizes and zoom levels, free from any aliasing artifacts. Below, you can explore a demo of our implementation set within a ThreeJS 3D environment. Feel free to adjust the zoom and observe the crisp, clear quality of the text rendering.
        </p>
      </div>
      <div class="flex flex-col gap-2 items-center justify-center">
        <canvas class="rounded-lg border-2 border-sky-500" id="webgl" width="940" height="320" style={{ width: '940px', height: '420px'}}></canvas>
        <div class="flex items-center gap-2">
          <p class="text-center">Canvas 1, <span class="font-bold">Controls:</span></p>
          <p class="text-center">Click (Change Perspective), Double Click (Move), Scroll (Zoom In/Out)</p>
          <p class="underline decoration-sky-500"><b>Rendering Time</b>: {gpuRenderTime.toFixed(2)} milliseconds</p>
        </div>
      </div>
      <div class="flex flex-col gap-3">
        <h2 class="text-2xl text-center font-bold underline decoration-sky-500 text-center">Glyphs</h2>
        <p>
        To understand the basics of Font Rendering, we first looked at how fonts are actually represented computationally and how they are rendered on our screens. We found that Fonts are essentially a collection of glyphs, each of which represent a character in the specified font. Glyphs store the control and on-curve points which determine the Bézier curve that represents the outline of the characters that we are trying to render. <br/>
        

        </p>
        <p>
          <InlineMath math={"Q(t) = (1 - t)^2P_0 + 2(1 - t)tP_1 + t^2P_2"}/> <br/>
          <InlineMath math={"C(t) = (1 - t)^3P_0 + 3(1 - t)^2tP_1 + 3(1 - t)^2P_2 + t^3P_3"}/>
        </p>
        <p>
        During our preparation for the milestone, we used FreeType and OpenType libraries for parsing .ttf and .otf font files. This gave us a good understanding of working with font files. We ended up writing a basic rasterizer in Python to render the Bezier points (Figure 1) and the contour of a glyph (Figure 2). This visualization cemented our understanding of basic font representation. <br/>
        The Glyph structure enabled us to also render characters on the CPU via the OpenType API and the JS Canvas API. This served as a benchmark for performance evaluation once we began to utilize the GPU to accelerate our text rendering process.
        </p>
        <div className="flex items-center justify-center gap-3">
          <div class="flex flex-col items-center gap-2">
            <img className='h-64' src="glyph-1.png"></img>
            <p class="text-sm">Figure 1: Bezier Points [1]</p>
          </div>
          <div class="flex flex-col items-center gap-2">
            <img className='h-64' src="glyph-2.png"></img>
            <p class="text-sm">Figure 2: Glyph Contour through Bezier Curves [1]</p>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <h2 class="text-2xl text-center font-bold underline decoration-sky-500 text-center">Signed Distance Fields (SDF)</h2>
        <p>
        Rendering vector graphics across different resolutions can be a tedious and computational expensive task. Signed Distance Fields (SDFs) provide an efficient way to render smooth vectors across different sizes (resolutions). SDFs work creating a grid of the vector and the surrounding area. Each pixel is mapped to a value depending on its distance from the edges of the vector. Negative values indicate that a pixel is outside the edge (exterior), positive values indicate pixel values that are inside the vector. SDFs can be further simplified visually by thinking of each pixel square as the center of its own proper circle. The radius of the circle is the shortest distance towards the nearest points in the vector’s edge. The radius of each circle can extend inwards and onwards depending whether the circle is outside or inside the vectors.  Once we have a point value P, sample using bilinear sampling using the following formula:
        </p>
        <p>
        <InlineMath math={"P(x,y)=(1−tx)(1−ty)⋅ f(Q_{11})+tx(1−ty)⋅f(Q_{21})+(1−tx)ty⋅f(Q_{12})+txty ​⋅ f(Q_{22})"}/>
        </p>
        <ul class="list-disc list-inside">
          <li><InlineMath math={"P(x,y)"}/> is the interpolated value at the target point <InlineMath math={"(x,y)"}/>:</li>
          <li><InlineMath math={"f(Qij)f(Q\_{ij})f(Qij​)"}/> represents the known values at the four corners of the grid cell surrounding the point. Specifically:
            <ul class="list-decimal list-inside pt-1">
              <li><InlineMath math={"Q\_{11}"}/> is the top-left corner</li>
              <li><InlineMath math={"Q\_{21}"}/> is the top-right corner</li>
              <li><InlineMath math={"Q\_{12}"}/> is the bottom-left corner</li>
              <li><InlineMath math={"Q\_{22}"}/> is the bottom-right corner</li>
            </ul>
          </li>
        </ul>
        <div className="flex flex-col gap-6">
          <div className="flex items-center justify-center gap-3">
            <div class="flex flex-col items-center gap-2">
              <img className='h-64' src="distance-fields.png"></img>
              <p class="text-sm">Figure 3: Distance Fields from [1]</p>
            </div>
            <div class="flex flex-col items-center gap-2">
              <img className='h-64' src="distance-fields-circles.png"></img>
              <p class="text-sm">Figure 4: Distance Fields as circles from [1]</p>
            </div>
          </div>
          <div className="flex items-center justify-center gap-3">
            <div class="flex flex-col items-center gap-2">
              <img className='h-64' src="sdf.png"></img>
              <p class="text-sm">Figure 5: SDF Texture generated through msdf-gen</p>
            </div>
            <div class="flex flex-col items-center gap-2">
              <img className='h-64' src="resulting-sdf-glyph.png"></img>
              <p class="text-sm">Figure 6: Resulting glyph from texture-mapping SDF[1]</p>
            </div>
          </div>
        </div>
        <p>
        We've researched the Slug algorithm, which directly incorporates vector data of fonts into the shader, effectively reducing texture generation overheads for font atlases on the CPU side while rendering text on the fly. The numerical solutions to the root finding of traditional approaches, which compute the intersections between curves and a ray fired from the sampling point, are susceptible to rounding errors, particularly at points of tangency, resulting in visual artifacts.
        The Slug algorithm aims to enhance the traditional approach by circumventing inefficiencies with floating-point numbers. It introduces a novel classification approach. This categorizes bezier curves into eight equivalence classes, each corresponding to a different pair of winding numbers contributed by two possible intersections along the curves.
        Nonetheless, the Slug algorithm is computationally demanding, as sampling is done pixel by pixel. This method can be asymptotically slower than other approaches, despite employing optimizations such as banding, which only improve results by some constant factor.
        </p>
        <div className="flex items-center justify-center gap-3">
            <div class="flex flex-col items-center gap-2">
              <img className='h-72' src="bezier-sdf.png"></img>
              <p class="text-sm">Figure 7 [4]</p>
            </div>
          </div>
      </div>
      <div className="flex flex-col gap-3">
        <h2 class="text-2xl text-center font-bold underline decoration-sky-500 text-center">Multi-Channel Distance Fields (MSDF)</h2>
        <p>
        Multi-channel distance fields (MSDFs) address a limitation of Signed Distance Fields (SDFs): the inability to render fonts with high precision due to the lack of sharp corners. What the approach in Chlumsky’s paper [1] outlines is that instead of drawing a texture by taking the union of a list of circles, we can take the intersection of the union of a list of circles. The way this works is that MSDF texture creation draws distance fields based on the 3 main color channels-Red, Green, Blue. Whenever it finds a sharp edge, it changes color channels as depicted in Figure 8. Thus, this adaptive color switch produces a method to determine when two or more colors agree on a pixel being inside the glyph. If the colors of a pixel in the texture are white, cyan, magenta, or yellow, then that pixel is inside the glyph. 
        If the color is black, red, green, or blue, then the pixel is outside of the glyph. By using this method in texture mapping, we are able to accurately represent sharp corners like in the picture of letter ‘A’ in Figure 9. 
        </p>
        <div className="flex items-center justify-center gap-3">
          <div class="flex flex-col items-center gap-2">
            <img className='h-72' src="msdf-generation.jpg"></img>
            <p class="text-sm">Figure 8: MSDF Construction from [1]</p>
          </div>
          <div class="flex flex-col items-center gap-2">
            <img className='h-72' src="resulting-msdf-glyph.png"></img>
            <p class="text-sm">Figure 9: Resulting glyph from texture-mapping MSDF</p>
          </div>
        </div>
      </div>
      <div class="flex flex-col items-center gap-3">
        <h2 class="text-2xl text-center font-bold underline decoration-sky-500 text-center">Challenges</h2>
        <p>The biggest challenge that we encountered is that we tried to generate the MSDF textures ourselves. Reading through Chlumsky’s paper and researching how other people implemented msdf texture generation, we thought that the implementation would be easy. However, after spending countless hours, we found there is a reason Chlumsky wrote their entire Master’s thesis about this: the task is non-trivial and requires a lot of graphics experience. In fact, the state-of-the-art in generating msdf textures is the library called msdfgen [2] by Chlumsky and 13 other experienced graphics engineers. 
          We ended up using that library and you can see in Figure 10 the texture that we used for our texture mapping implementation. At the end of the day, we realized that the focus of our project should be texture mapping the MSDF and showcasing the performance optimization of GPU font rendering.
        </p>
        <p>
          The second challenge that we faced is the constantly updated ways of rendering animations in ThreeJS. Although it is a powerful library, the way its environment works gets updated frequently, which made it impossible to follow an online tutorial or implementation since things that worked in a past version do not apply in our environment. 
          The way we solved this is by going over the ThreeJS documentation [3] and writing small programs to get familiarized with the library. Thus, we were able to generated the renderings and shaders on the website from scratch.
        </p> 
        <div className="flex items-center justify-center gap-3">
          <div class="flex flex-col items-center gap-2">
            <img className='h-64' src="msdf.png"></img>
            <p class="text-sm">Figure 10: MSDF Texture generated through the msdfgen library</p>
          </div>
        </div>
      </div>
      <div class="flex flex-col items-center gap-3">
        <h2 class="text-2xl text-center font-bold underline decoration-sky-500 text-center">Texture Mapping</h2>
        <p>
        Texture mapping was the hardest part of the project, since the msdf texture had to be loaded on a ThreeJS Shader Material through a WebGL shader program for high-precision font rendering that supports sharp corners. The fragment shader in our code processes each pixel's color based on its position relative to the font outline. We used a median function to calculate the median of the red, green, and blue channels of the texture color. Thus, we are able to determine the “middle” distance among the three color channels to represent the edge of the glyph. Pixels with an alpha value below a minimal threshold are discarded to avoid rendering artifacts.
        </p>
        <p>
        
In traditional texture mapping of fonts, each glyph is mapped based on its size within the texture, which can lead to suboptimal rendering of very large font sizes. By utilizing the color intersection scheme from multi-channel signed distance fields (MSDF), our implementation overcomes this limitation. This approach allows for effective mapping of fonts at varying sizes, and supports smooth zooming in and out within a 3D environment. This feature is particularly beneficial for applications in gaming and animated text.
        </p>
      </div>
      <div class="flex flex-col items-center gap-3">
        <h2 class="text-2xl text-center font-bold underline decoration-sky-500 text-center">Lessons Learned</h2>
        <p>
          Through this project, we researched a lot of approaches for rendering text. Most importantly, exploring the intricacies of GPU font-rendering, which is a fairly novel concept, was one of the main takeaways from this project.
          Moreover, we improved our skills as Graphics engineers by working with the complex library Three.js and attempting multiple GPU rasterizers in C++ as well. ThreeJS is mainly used in online resources in VanillaJS web applications. However,
          because of prior experience with React applications, we were able to put together the ThreeJS environment in this React App. We used React because we wanted to allow visitors on our writeup to render the text that they want interactively. In this way,
          we were able to show show how much more performant GPU Font Rendering is for user-typed text. 
        </p>
      </div>
      <div class="flex flex-col items-center gap-3">
        <h2 class="text-2xl text-center font-bold underline decoration-sky-500 text-center">Performance Optimization: Results</h2>
        <p>
          To analyze our performance, we replicated the text rasterization process commonly used by computers in many applications. Typically, a computer utilizes its CPU to interpret glyphs from a font file and display them on the screen. In our emulation, we used the OpenType library to obtain glyph outlines. To fill the glyphs, we used the .draw function in the OpenType library and we also manually drew the text on the canvas through the Canvas API. Our implementation, which uses MSDF texture mapping, runs on the local GPU of the user accessing the website because it runs on a WebGL environment. Thus, we are able to render the fonts on the GPU and achieve better performance than the usual CPU rasterizer found in the software programs that we use every day.
        </p>
        <p>
          <b>Warning: </b> If you attempt to render longer strings, the first two canvases will not render the entire text because of the capped width of the component.
        </p>
        {/* <div class="flex g-5"> */}
          <div class="mb-4 pt-5">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="username">
              Input Text
            </label>
            <div class="flex gap-3">
              <input class="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="username" type="text" placeholder="Text" value={inputValue} onChange={handleInputChange}/>
              <button class="bg-sky-500 hover:bg-blue-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="button" onClick={handleRenderText}>
                Render Text
              </button>
            </div>
          </div>
          
        {/* </div> */}
        <div class="flex flex-col items-center">
          <canvas class="rounded-lg border-2 border-sky-500" ref={canvasCPURef} width="940" height="320" style={{ width: '940px', height: '300px' }}></canvas>
          <p>Canvas 2: Manually Rendering Glyphs with the Canvas API (CPU); <b>Rendering Time: {cpuRenderTime.toFixed(3)} milliseconds</b> </p>
        </div>
        <div class="flex flex-col items-center">
          <canvas class="rounded-lg border-2 border-sky-500" ref={canvasRef} width="940" height="320" style={{ width: '940px', height: '300px' }}></canvas>
          <p>Canvas 3: Glyph Rendering with the OpenType library (CPU); <b>Rendering Time: {openTypeRenderTime.toFixed(3)} milliseconds</b> </p>
        </div>
        {/* <p>Font Rendering with OpenType took {openTypeRenderTime.toFixed(3)} milliseconds</p> */}
        <div class="flex flex-col items-center">
        <canvas class="rounded-lg border-2 border-sky-500" id="webgltest" width="940" height="320" style={{ width: '940px', height: '420px'}}></canvas>
          <p>Canvas 4: Rendering Glyphs through texture mapping MSDF (GPU); <b>Rendering Time: {gpuPerformanceTime.toFixed(3)} milliseconds</b> </p>
          <div class="flex items-center gap-2">
          <p class="text-center"><span class="font-bold">Controls:</span></p>
          <p class="text-center">Click (Change Perspective), Double Click (Move), Scroll (Zoom In/Out)</p>
          </div>
        </div> 
      </div>
      <div class="flex flex-col items-center gap-3">
        <h2 class="text-2xl text-center font-bold underline decoration-sky-500 text-center">Contributions</h2>
      </div>
      <div class="flex flex-col gap-3">
        <div>
        <p><span class="underline decoration-sky-500">Razvan</span>:</p>
         <ul class="list-disc">
          <li>
          Wrote the following sections of the writeup: Abstract, MSDF, Challenges, Texture Mapping, Lessons Learned, Performance Optimizations, References.
          </li>
          <li>
          Wrote the shader code for mapping MSDFs on a canvas.
          </li>
          <li>
          Wrote the logic for mapping text based on user input, integrated ThreeJS with the React app of the website.
          </li>
          <li>
          Generated the MSDF textures for the shader program through the msdfgen library.
          </li>
          <li>
          Wrote the CPU rasterization through the OpenFont library and through the Canvas API and enabled performance comparisons for the different methods of font rendering.
          </li>
          <li>
          Wrote the milestone code for parsing font files.
          </li>
          <li>
          Recorded the milestone video; helped on the milestone write-up, presentation.
          </li>
          <li>
          Researched methods for rendering text through the GPU.
          </li>
          <li>
          Researched the ThreeJS documentation and wrote a series of small ThreeJS programs to familiarize with the environment
          </li>
          <li>
          Recorded the final showcase video, helped with the final presetation
          </li>
        </ul>
        </div>
        <div>
        <p><span class="underline decoration-sky-500">Ziyan</span>:</p>
         <ul class="list-disc">
          <li>
          Worked on a fragrant shader that intended to rasterize the vector data using the Slug approach; integrated the shader into a standalone HTML file.
          </li>
          <li>
          Wrote the final report on the rendering of fonts through vector textures.
          </li>
          <li>
          Researched on the possible approaches to represent the result of the shaders.
          </li>
          <li>
          Recorded the final showcase video, helped with the final presetation
          </li>
        </ul>
        </div>
        <div>
        <p><span class="underline decoration-sky-500">Angel</span>:</p>

         <ul class="list-disc">
          <li>
          Helped write and hosted milestone webpage and proposal.
          </li>
          <li>
          Researched GPU rendering methods
          </li>
          <li>
          Assisted in development of an OpenGL pipeline which was eventually discarded in favor of WebGL and Three.js
          </li>
          <li>
          Helped with final writeup and slide deck used for the presentation
          </li>
          <li>
          Recorded the final showcase video, helped with the final presetation
          </li>
        </ul>
        </div>
        <div>
        <p><span class="underline decoration-sky-500">Luis</span>:</p>

         <ul class="list-disc">
          <li>
          Researched initial topics ideas and further research font rendering methods
          </li>
          <li>
          Researched efficient rendering methods for glyphs
          </li>
          <li>
          Developed OpenGL font rendering pipeline design until we pivoted to WebGL
          </li>
          <li>
          Contributed with the final report writeup and slide deck
          </li>
          <li>
          Recorded the final showcase video, helped with the final presetation
          </li>
        </ul>
        </div>
      </div>
      <div class="flex flex-col gap-2">
        <h2 class="text-2xl text-center font-bold underline decoration-sky-500 text-center">References</h2>
        <p>[1] Shape Decomposition for Multi-channel Distance Fields, Bc. Viktor Chlumsky: <a class="underline decoration-sky-500" href="https://github.com/Chlumsky/msdfgen/files/3050967/thesis.pdf">Link</a></p>
        <p>[2] MSDF Generator, msdfgen repository: <a class="underline decoration-sky-500" href="https://github.com/Chlumsky/msdfgen?tab=readme-ov-file">Link</a></p>
        <p>[3] ThreeJS documentation: <a class="underline decoration-sky-500" href="https://threejs.org/docs/index.html#manual/en/introduction/Creating-a-scene">Link</a></p>
        <p>[4] GPU-Centered Font Rendering Directly from Glyph Outlines, Eric Lengyel et. al.: <a class="underline decoration-sky-500" href="https://jcgt.org/published/0006/02/02/">Link</a></p>
      </div>
      <div class="flex flex-col gap-2 text-center">
        <h2 class="text-2xl text-center font-bold underline decoration-sky-500 text-center"><a class="underline decoration-sky-500" href="https://youtu.be/nIrg8CCp4Rc">Video Link</a></h2>
      </div>
    </div>
  );
};

export default App;
